import { CARE_TYPE_INPATIENT, CARE_TYPE_OUTPATIENT, careTypeLabel } from 'constants/treatment';

export const VISIT_SORT_NEWEST = 'newest';
export const VISIT_SORT_OLDEST = 'oldest';

export const VISIT_FILTER_ALL = 'all';
export const VISIT_FILTER_OUTPATIENT = 'outpatient';
export const VISIT_FILTER_INPATIENT = 'inpatient';
export const VISIT_FILTER_SUPPLEMENTARY = 'supplementary';

export const VISIT_KIND_INPATIENT_SUPPLEMENTARY = 'inpatient_supplementary';

export function isInpatientSupplementaryVisit(visit) {
  return visit?.visitKind === VISIT_KIND_INPATIENT_SUPPLEMENTARY;
}

export function visitSortKey(visit) {
  const date = visit?.date || '';
  const time = visit?.time || '00:00';
  return `${date}T${time}`;
}

export function filterAndSortVisits(visits, { sort = VISIT_SORT_NEWEST, careFilter = VISIT_FILTER_ALL } = {}) {
  let list = Array.isArray(visits) ? [...visits] : [];

  if (careFilter === VISIT_FILTER_OUTPATIENT) {
    list = list.filter(
      (v) => (v.careType ?? v.care_type) !== CARE_TYPE_INPATIENT && !isInpatientSupplementaryVisit(v)
    );
  } else if (careFilter === VISIT_FILTER_INPATIENT) {
    list = list.filter(
      (v) =>
        (v.careType ?? v.care_type) === CARE_TYPE_INPATIENT && !isInpatientSupplementaryVisit(v)
    );
  } else if (careFilter === VISIT_FILTER_SUPPLEMENTARY) {
    list = list.filter((v) => isInpatientSupplementaryVisit(v));
  }

  list.sort((a, b) => {
    const ka = visitSortKey(a);
    const kb = visitSortKey(b);
    if (sort === VISIT_SORT_OLDEST) {
      return ka.localeCompare(kb);
    }
    return kb.localeCompare(ka);
  });

  return list;
}

export function visitCareBadge(careType, visit) {
  if (isInpatientSupplementaryVisit(visit)) {
    return {
      label: 'Доп. услуга',
      isInpatient: true,
      isSupplementary: true,
    };
  }
  const type = careType || CARE_TYPE_OUTPATIENT;
  return {
    label: careTypeLabel(type),
    isInpatient: type === CARE_TYPE_INPATIENT,
    isSupplementary: false,
  };
}

export function supplementaryPaymentLabel(method, isDebt) {
  if (isDebt) return 'Долг';
  if (method === 'cash') return 'Наличные';
  if (method === 'online') return 'Онлайн';
  return method || '—';
}
